import { api } from '../../../../helpers';

const getComments = async (id, page = 1, ordering = 'created_at') => {
  const path = `/api/v1/parent-comment/list/${id}/?page=${page}&ordering=${ordering}`;

  const response = await api(path);
  let data = await response.json();

  data.results.map((el) => {
    el.childrens = [];
    return el;
  });

  return Object.values(data);
}

export { getComments };